import React, { useEffect, useRef, useState } from 'react';
import CardBox from '../CardBox';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import ReactEcharts from 'echarts-for-react';
import { getChartOption } from './chart';
import { LightingElecConsumptionData } from '../../data';
import { Spin } from 'antd';

const LightingElecConsumption = () => {
  const chartRef = useRef<ReactEcharts>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleResize = () => {
    const echartsInstance = chartRef.current?.getEchartsInstance();
    if (echartsInstance) {
      echartsInstance.resize();
    }
  };

  const containerRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const echartsInstance = chartRef.current?.getEchartsInstance();
      if (echartsInstance) {
        echartsInstance.resize();
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <CardBox title="全厂用量-照明用电量" subTitle={dayjs().format('YYYY-MM-DD')} className={styles.cardBoxSty}>
      {loading ? (
        <Spin spinning={loading} />
      ) : (
        <div className={styles.charts_wrapper} ref={containerRef}>
          <ReactEcharts
            style={{ height: '100%' }}
            ref={d => {
              if (d) {
                chartRef.current = d;
              }
            }}
            option={getChartOption(LightingElecConsumptionData)}
            notMerge
            lazyUpdate={false}
          />
        </div>
      )}
    </CardBox>
  );
};

export default LightingElecConsumption;
